import ReactCountryFlag from 'react-country-flag';
import { MdOutlineRemoveCircle } from 'react-icons/md';
import { useCountryContext } from '../../../contexts/CountryProvider';

const SelectedCountryModalTable = () => {
  // integration of context hooks here
  const { selectedCountries, setSelectedCountries } = useCountryContext();

  // rendering selected country modal table component here
  return (
    <div className='overflow-x-auto md:overflow-x-hidden border-2 border-dashed border-legal-dark-blue rounded-lg'>
      <div className='min-w-[450px] grid grid-cols-[50px_190px_80px_80px_50px] border-b-2 border-dashed border-legal-dark-blue text-center text-base-dark-blue font-semibold [&>p:not(:last-child)]:border-r [&>p:not(:last-child)]:border-dashed [&>p:not(:last-child)]:border-legal-dark-blue [&>p]:p-1'>
        <p></p>
        <p>Name</p>
        <p>ISO Code</p>
        <p>ISD Code</p>
        <p></p>
      </div>

      <div className='min-w-[450px] [&>div:not(:last-child)]:border-b [&>div:not(:last-child)]:border-dashed [&>div:not(:last-child)]:border-legal-dark-blue'>
        {selectedCountries.map((country, index) => (
          <div
            key={index}
            className='grid grid-cols-[50px_190px_80px_80px_50px] text-center text-base-dark-blue [&>div:not(:last-child)]:border-r [&>div:not(:last-child)]:border-dashed [&>div:not(:last-child)]:border-legal-dark-blue [&>div]:p-1'
          >
            <div>
              <ReactCountryFlag
                style={{ width: '1.5em', height: '1.42em' }}
                countryCode={country.iso_code}
                svg
              />
            </div>

            <div title={country.country_name}>
              <p className='truncate'>{country.country_name}</p>
            </div>

            <div>
              <p>{country.iso_code}</p>
            </div>

            <div>
              <p>{country.isd_code}</p>
            </div>

            <div className='flex items-center justify-center'>
              <button
                title='Remove Country'
                type='button'
                onClick={() =>
                  setSelectedCountries((state) =>
                    state.filter(
                      (existingCountry) =>
                        existingCountry.iso_code !== country.iso_code
                    )
                  )
                }
                className='rounded-full'
              >
                <MdOutlineRemoveCircle className='size-5 text-base-red hover:opacity-70 duration-300' />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectedCountryModalTable;
